import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbaniahireforcorporateevets() {



  const cardData = {
"keyword": "Urbania Hire for Corporate Events in Pune",

"headingDescription":
  "Aaradhya Travels offers premium Urbania Hire for Corporate Events in Pune for business meetings, conferences, employee transportation, corporate outings, exhibitions, seminars, airport transfers, and executive group travel requirements. Our Force Urbania fleet features luxurious seating, air-conditioning, spacious interiors, luggage space, pushback seats, charging points, music systems, and experienced drivers familiar with Pune corporate hubs and highways. We ensure safe, comfortable, and punctual transportation with doorstep pickup services for corporate teams and business travelers across Pune.",

"topPlaces": [
{
"title": "Navi Mumbai",
"description":
"Navi Mumbai is a planned city known for clean infrastructure, parks, malls, and business hubs. It is commonly visited for corporate group travel, events, and city tours."
},
{
"title": "Elephanta Caves",
"description":
"Elephanta Caves are UNESCO World Heritage rock-cut caves located on an island near Mumbai known for ancient sculptures and historical significance. It is a popular heritage group tour destination."
},
{
"title": "Mumbai",
"description":
"Mumbai is the financial capital of India known for Marine Drive, Gateway of India, Juhu Beach, Bollywood, shopping streets, and vibrant city life. It is one of the most popular group travel destinations from Pune for corporate tours, shopping trips, and leisure outings."
},
{
"title": "Matheran",
"description":
"Matheran is Asia’s only automobile-free hill station near Mumbai known for toy train rides, viewpoints, dense greenery, and cool weather. It is a peaceful weekend getaway for families and group travelers from Pune and Mumbai."
},
{
"title": "Alibaug",
"description":
"Alibaug is a coastal beach destination near Mumbai known for clean beaches, sea forts, water sports, and relaxed seaside atmosphere. It is a popular group tour destination for short trips from Pune."
},
{
"title": "Lonavala",
"description":
"Lonavala is a famous hill station near Mumbai and Pune known for waterfalls, caves, green valleys, and monsoon beauty. It is a highly visited weekend destination for group bus and Tempo Traveller trips."
},
{
"title": "Khandala",
"description":
"Khandala is known for scenic valleys, misty hills, and natural viewpoints. It is a short and relaxing getaway destination popular among families and group travelers from Mumbai and Pune."
},

{
"title": "Imagicaa Theme Park",
"description":
"Imagicaa is a large theme park near Mumbai offering rides, entertainment zones, and water parks. It is a popular destination for school trips, corporate outings, and family group tours."
},
{
"title": "Karjat",
"description":
"Karjat is a scenic green valley near Mumbai known for waterfalls, rivers, resorts, and adventure activities. It is widely chosen for weekend group trips and corporate outings."
},
{
"title": "Khopoli",
"description":
"Khopoli is known for industrial areas, waterfalls nearby, and proximity to Imagicaa theme park. It is a convenient stopover destination for group travel between Pune and Mumbai."
}
],



services: [
  {
    name: "Urbania on Rent for Corporate Travel Pune",
    description: "Urbania on rent for corporate travel Pune service provides premium transportation for office staff, executive travel, business meetings, conferences, and employee outings. Spacious seating and modern interiors ensure smooth journeys suitable for corporate passenger groups and business travel requirements. Professional chauffeurs ensure dependable transportation and punctual pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient corporate Urbania reservations."
  },
  {
    name: "Urbania for Corporate Office Staff Pickup Pune",
    description: "Urbania for corporate office staff pickup Pune service offers dependable transportation for employee commute, office shuttle services, business travel, and daily corporate transportation requirements. Comfortable seating and spacious interiors ensure pleasant journeys suitable for office staff and executive passengers. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from offices, IT parks, residential areas, and business hubs across Pune. Flexible booking options allow convenient corporate staff Urbania reservations."
  },
  {
    name: "Urbania Traveller for Corporate Events Pune",
    description: "Urbania traveller for corporate events Pune service provides luxury transportation for conferences, seminars, office gatherings, exhibitions, and business functions. Spacious seating and smooth travel ensure comfortable journeys suitable for executive passengers and corporate groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from offices, hotels, airports, and event venues across Pune. Flexible booking options allow convenient corporate event Urbania reservations."
  },
  {
    name: "Corporate Event Urbania Hire Pune",
    description: "Corporate event Urbania hire Pune service offers premium transportation for office events, team outings, executive meetings, exhibitions, and employee travel requirements. Spacious interiors and modern seating ensure pleasant journeys suitable for local and outstation corporate transportation. Professional chauffeurs ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from offices, commercial hubs, hotels, and airports across Pune. Flexible booking options allow convenient corporate event Urbania hire reservations."
  },
  {
    name: "Urbania for Corporate Group Travel Pune",
    description: "Urbania for corporate group travel Pune service provides spacious transportation for office teams, business conferences, employee outings, airport transfers, and executive travel requirements. Comfortable seating and luggage space ensure smooth journeys suitable for medium-sized corporate passenger groups. Professional chauffeurs ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from offices, hotels, airports, and business locations across Pune. Flexible booking options allow convenient corporate group Urbania reservations."
  },
  {
    name: "Luxury Urbania on Rent for Events Pune",
    description: "Luxury Urbania on rent for events Pune service provides elegant transportation with modern interiors and spacious seating for weddings, corporate events, family functions, and VIP travel. Smooth travel and premium comfort ensure pleasant journeys suitable for executive passengers and social gatherings. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, luxury hotels, offices, airports, and event venues across Pune. Flexible booking options allow convenient luxury event Urbania reservations."
  },
  {
    name: "13 Seater Urbania on Rent in Pune",
    description: "13 seater Urbania on rent in Pune service offers luxury transportation for family vacations, business travel, airport transfers, sightseeing tours, and group travel requirements. Spacious seating and premium interiors ensure comfortable journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient 13 seater Urbania reservations."
  },
  {
    name: "13 Seater Urbania Traveller Pune",
    description: "13 seater Urbania traveller Pune service provides reliable transportation for sightseeing tours, family outings, weddings, and office travel requirements. Comfortable seating and smooth travel ensure pleasant journeys suitable for local and outstation passenger movement. Professional drivers ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient 13 seater Urbania traveller reservations."
  },
  {
    name: "13 Seater Urbania Hire in Pune",
    description: "13 seater Urbania hire in Pune service offers spacious transportation for airport transfers, tourist travel, family group journeys, and executive transportation. Premium interiors and luggage space ensure comfortable journeys suitable for local and long-distance travel requirements. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and railway stations across Pune. Flexible booking options allow convenient 13 seater Urbania hire reservations."
  },
  {
    name: "13 Seater Urbania Booking Pune",
    description: "13 seater Urbania booking Pune service provides luxury transportation for weddings, sightseeing tours, business trips, airport travel, and family vacations. Spacious seating and smooth highway travel ensure pleasant journeys suitable for local and outstation travel requirements. Professional drivers ensure punctual transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, airports, and residential areas across Pune. Flexible booking options allow convenient 13 seater Urbania booking reservations."
  },
  {
    name: "13 Seater Urbania Van on Rent Pune",
    description: "13 seater Urbania van on rent Pune service offers dependable transportation for educational tours, office outings, wedding travel, and family group trips. Spacious interiors and comfortable seating ensure smooth journeys suitable for medium-sized passenger groups. Professional chauffeurs ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, schools, offices, hotels, and airports across Pune. Flexible booking options allow convenient 13 seater Urbania van rental reservations."
  },
  {
    name: "13 Seater Urbania for Outstation Pune",
    description: "13 seater Urbania for outstation Pune service provides premium long-distance transportation for Goa tours, hill station vacations, pilgrimage journeys, and family trips. Spacious seating and smooth highway travel ensure comfortable journeys suitable for all passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and airports across Pune. Flexible booking options allow convenient outstation Urbania reservations."
  },
  {
    name: "13 Seater Urbania on Rent Near Me Pune",
    description: "13 seater Urbania on rent near me Pune service provides dependable transportation for family outings, airport transfers, sightseeing tours, weddings, and corporate travel. Spacious interiors and comfortable seating ensure smooth journeys suitable for local and outstation passenger movement. Professional chauffeurs ensure punctual transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, and residential areas across Pune. Flexible booking options allow convenient nearby Urbania rental reservations."
  },
  {
    name: "13 Seater Luxury Urbania Rental Pune",
    description: "13 seater luxury Urbania rental Pune service provides premium transportation with elegant interiors and comfortable seating for weddings, corporate travel, airport transfers, and family vacations. Smooth highway travel ensures pleasant journeys suitable for executive passengers and tourist groups. Professional chauffeurs ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and airports across Pune. Flexible booking options allow convenient luxury Urbania rental reservations."
  },
  {
    name: "13 Seater Urbania for Family Trip Pune",
    description: "13 seater Urbania for family trip Pune service offers dependable transportation for holiday vacations, sightseeing tours, pilgrimage journeys, and family outings. Spacious seating and comfortable interiors ensure pleasant journeys suitable for local and outstation family group travel. Professional chauffeurs ensure reliable transportation and safe driving services throughout the route. Pickup services are available from homes, hotels, offices, and residential areas across Pune. Flexible booking options allow convenient family trip Urbania reservations."
  },
  {
    name: "13 Seater Urbania for Group Travel Pune",
    description: "13 seater Urbania for group travel Pune service provides spacious transportation for educational tours, sightseeing journeys, office outings, family vacations, and tourist travel. Comfortable seating and smooth travel ensure pleasant journeys suitable for medium-sized passenger groups. Professional drivers ensure dependable transportation and safe driving services throughout the route. Pickup services are available from homes, offices, hotels, airports, and residential areas across Pune. Flexible booking options allow convenient group travel Urbania reservations."
  }
],

tableData: [
  ["Urbania on Rent for Corporate Travel Pune", "Urbania for Corporate Office Staff Pickup Pune"],
  ["Urbania Traveller for Corporate Events Pune", "Corporate Event Urbania Hire Pune"],
  ["Urbania for Corporate Group Travel Pune", "Luxury Urbania on Rent for Events Pune"],
  ["13 Seater Urbania on Rent in Pune", "13 Seater Urbania Traveller Pune"],
  ["13 Seater Urbania Hire in Pune", "13 Seater Urbania Booking Pune"],
  ["13 Seater Urbania Van on Rent Pune", "13 Seater Urbania for Outstation Pune"],
  ["13 Seater Urbania on Rent Near Me Pune", "13 Seater Luxury Urbania Rental Pune"],
  ["13 Seater Urbania for Family Trip Pune", "13 Seater Urbania for Group Travel Pune"]
],





 whychoose: [
      {
        WhyChooseheading: "Reliable Urbania Hire for Corporate Events in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Urbania hire service for corporate events in Pune with luxury vehicles, professional drivers, and smooth transportation arrangements for business meetings, conferences, and employee travel."
      },
      {
        WhyChooseheading: "Affordable Corporate Urbania Rental Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Urbania rental packages for corporate events in Pune with transparent pricing, flexible booking plans, and complete travel support without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Corporate Transportation Service",
        WhyChoosedescription: "Our Force Urbania rental service in Pune operates 24 hours for corporate meetings, seminars, exhibitions, airport transfers, employee transportation, business tours, and executive travel."
      },
      {
        WhyChooseheading: "Comfortable AC Luxury Urbania Vehicles",
        WhyChoosedescription: "All Force Urbania vehicles provided by Aaradhya Travels are spacious, air-conditioned, clean, and regularly maintained for premium and comfortable corporate group travel experiences."
      },
      {
        WhyChooseheading: "Customized Corporate Travel Packages",
        WhyChoosedescription: "Aaradhya Travels offers customized travel solutions for office outings, conferences, staff transportation, VIP guest transfers, corporate events, and multi-day business travel requirements."
      },
      {
        WhyChooseheading: "Multiple Seating Capacity Urbania Options",
        WhyChoosedescription: "Customers can choose from 9 seater, 13 seater, and 17 seater luxury Force Urbania vehicles suitable for corporate teams, executives, clients, and event guest transportation."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides convenient pickup from Hinjewadi, Baner, Wakad, Kharadi, Magarpatta, Hadapsar, Viman Nagar, Pune Airport, hotels, and all major corporate locations in Pune."
      },
      {
        WhyChooseheading: "Experienced Drivers for Professional Corporate Travel",
        WhyChoosedescription: "Our experienced drivers ensure safe driving, smooth coordination, punctual arrivals, and professional transportation service for local and outstation corporate events."
      }
    ]
  };

  const faqData = [
    { question: "What is Urbania hire for corporate events in Pune?", answer: "Urbania hire for corporate events in Pune provides luxury group transportation using premium Force Urbania vehicles for business meetings, conferences, employee travel, and executive transportation." },
    { question: "Is Urbania booking available 24 hours in Pune?", answer: "Yes, Aaradhya Travels provides 24/7 Force Urbania rental service for corporate events in Pune." },
    { question: "Which seating options are available in Urbania?", answer: "Aaradhya Travels offers 9 seater, 13 seater, and 17 seater Force Urbania vehicles for different corporate travel requirements." },
    { question: "Can I book Urbania for corporate outstation trips from Pune?", answer: "Yes, customers can book Force Urbania for business tours, conferences, exhibitions, employee outings, and outstation corporate travel from Pune." },
    { question: "Do you provide Urbania for executive and VIP guest travel?", answer: "Yes, Aaradhya Travels provides luxury Force Urbania service for executives, VIP guests, corporate teams, and business clients." },
    { question: "Are all Urbania vehicles air-conditioned?", answer: "Yes, all Force Urbania vehicles are fully air-conditioned and maintained for comfortable luxury corporate travel." },
    { question: "Can I book Urbania online in Pune?", answer: "Yes, customers can easily book Force Urbania rental service online or through phone booking." },
    { question: "Do you provide airport pickup and drop service for corporate guests?", answer: "Yes, Aaradhya Travels provides airport pickup and drop service using luxury Force Urbania vehicles for corporate guests and employees." },
    { question: "Are Urbania rental charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for corporate Urbania rental service?", answer: "Yes, advance booking is available and recommended during corporate events, conferences, exhibitions, and peak business travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Deshmukh",
      feedback:
        "Booked Urbania hire for our corporate event in Pune with Aaradhya Travels. Luxury vehicle, punctual service, and excellent driver support for our team travel.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent Force Urbania rental service for our business conference in Pune. Clean vehicle, affordable pricing, and smooth executive travel experience.",
      rating: 5
    }
  ];


  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania Hire for Corporate Events in Pune",
  "image": "https://www.aaradhyatravels99.com/assets/images/urbania-corporate-events-pune.jpg",
  "description": "Book Urbania on rent in Pune for corporate events, office staff pickup, business travel, and group transport with Aaradhya Travels. Available 13, 17, and 20 seater luxury Urbania vans for corporate travel, airport transfers, and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "11820"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/urbania-hire-for-corporate-events-pune"
  }
};










  return (
    <div>

<Helmet>
  <title>
    Urbania Hire for Corporate Events in Pune | Office & Group Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Urbania for corporate events in Pune with Aaradhya Travels. Ideal for office staff pickup, corporate group travel, and business events. Available 13, 17, and 20 seater luxury Urbania vans with professional driver service."
  />

  <meta
    name="keywords"
    content="Urbania on Rent for Corporate Travel Pune, Urbania for Corporate Office Staff Pickup Pune, Urbania Traveller for Corporate Events Pune, Corporate Event Urbania Hire Pune, Urbania for Corporate Group Travel Pune, Luxury Urbania on Rent for Events Pune, 13 Seater Urbania on Rent in Pune, 13 Seater Urbania Traveller Pune, 13 Seater Urbania Hire in Pune, 13 Seater Urbania Booking Pune, 13 Seater Urbania Van on Rent Pune, 13 Seater Urbania for Outstation Pune, 13 Seater Urbania on Rent Near Me Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/85.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Urbaniahireforcorporateevets ;